<template id="app">
  <!-- <router-view v-if="isLoggedIn" v-slot="{ Component }"> -->

  <router-view v-slot="{ Component }">
    <!-- <BreadCrumb v-if="!$route.meta.hideBreadCrumb" /> -->
    <!-- <SidebarNav/> -->
    <!-- <TextLink
            style="    position: absolute !important;
left: 0; top: 0;
z-index: 1000;
writing-mode: vertical-rl;
transform: rotate(90deg);
"
            label="Jacques Ramphal"
            route="/"
            v-show="isDesktopScreen && !menuOpen"
          /> -->
    <!-- <MobileTOCBar
      :headings="markdownHeadings || []"
      :active-heading="markdownActiveHeading"
    /> -->
    <HeaderNav
      :toggle-menu="toggleMenu"
      v-if="!$route.meta.hideNav"
      :menu-open="menuOpen"
      :has-headings="markdownHeadings && markdownHeadings.length > 0"
      :headings="markdownHeadings || []"
      :active-heading="markdownActiveHeading"
    >
      <!-- Writing and Menu live in HeaderNav; the menu holds the rest -->
    </HeaderNav>
    <SectionStickyBar
      v-if="!$route.meta.hideNav && !menuOpen"
      :sections="stickySections"
      :desktop="$route.path.startsWith('/library')"
    />
    <!-- <ThemeButton v-if="!$route.meta.hideThemeButton" /> -->
    <!-- "page", not "fade": the old page leaves at once and the new one fades
         in, so two pages never share the layout (which showed the footer
         between them for a moment on every navigation). -->
    <transition name="page" :css="!viewTransitionActive">
      <component :is="Component" :key="$route.path" class="route-page" />
    </transition>

    <transition name="menu">
      <fullscreen-menu
        v-if="menuOpen"
        :is-open="menuOpen"
        @close="menuOpen = false"
      ></fullscreen-menu>
    </transition>

    <!-- <StickyNav v-if="!$route.meta.hideNav" :menu-open="menuOpen">
      <template v-slot:menu-button>
        <MyButton
          type="ghost"
          :label="menuOpen ? 'close' : 'menu'"
          @click="toggleMenu"
        />
      </template>
    </StickyNav> -->
    <!-- Subscribe bar, above the footer, on writing and open-source pages. This is the
         same plain placement the homepage uses (HomePage.vue), deliberately:
         the earlier full-bleed variant was parked for mobile overflow, and the
         inset band is the layout that already works at every width. The copy is
         article-aware so the ask refers to what was just read. -->
    <NewsletterBanner
      v-if="showSubscribeBar"
      :title="subscribeCopy.title"
      :text="subscribeCopy.text"
    />
    <MainFooter v-if="!$route.meta.hideFooter" />
    <!-- <SimpleFooter v-if="!$route.meta.hideFooter" /> -->

    <!-- <img
      src="./assets/images/work/3-avatar/01-sketches/avatar-standing/v02.png"
      alt=""
      aria-hidden="true"
      class="avatar-standing"
    />-->

    <CustomChatUI v-if="showChat" />
    <!-- Chat with Jacques' agent button and sidebar -->
    <!-- <div class="fixed-chat-entry" @click="toggleChatSidebar">
      <span class="vertical-text">chat with Jacques' agent</span>
    </div>
    <transition name="slide">
      <div v-if="showChatSidebar" class="chat-sidebar">
        <div class="chat-sidebar-header">
          <span>AI Chat (n8n agent)</span>
          <button class="close-btn" @click.stop="toggleChatSidebar">&times;</button>
        </div>
        <div class="chat-sidebar-content">
          <p>This is a placeholder for the n8n chat agent UI.</p>
        </div>
      </div>
    </transition> -->
  </router-view>
  <!-- <TheLogin v-else @TheLogin::loginResult="handleLoginResult" /> -->
</template>

<script lang="js">
import MyButton from './components/Button/Button.vue';

import NewsletterSubscription from './components/form/NewsletterSubscription.vue';
import FullscreenMenu from './components/FullscreenMenu.vue';
import StickyNav from './components/StickyNav.vue';
import HeaderNav from './components/HeaderNav/HeaderNav.vue';
import SectionStickyBar from './components/SectionStickyBar.vue';
import MainFooter from './components/MainFooter.vue';
import NewsletterBanner from './components/blog/NewsletterBanner.vue';
import TextLink from './components/text/TextLink.vue';
import MobileTOCBar from './components/MobileTOCBar.vue';
import SimpleFooter from './components/SimpleFooter.vue';
import TheLogin from './components/TheLogin.vue';
import SidebarNav from './components/SidebarNav.vue';
import CustomChatUI from './components/CustomChatUI.vue';
import { useRouter } from 'vue-router'; // Import Vue Router
import { provide, ref, computed } from 'vue';
import { viewTransitionActive } from './utils/viewTransitions';
export default {
  name: 'App',
  components: {
    StickyNav,
    HeaderNav,
    SectionStickyBar,
    MainFooter,
    NewsletterBanner,
    TextLink,
    MobileTOCBar,
    SimpleFooter,
    // ThemeButton,
    TheLogin,
    FullscreenMenu,
    MyButton,
    NewsletterSubscription,
    // BreadCrumb,
    SidebarNav,
    CustomChatUI,
  },
  setup() {
    const router = useRouter();
    const markdownHeadings = ref([]);
    const markdownActiveHeading = ref(null);
    // Section list fed by non-markdown pages (e.g. the Library) for the mobile
    // sticky section bar. Kept separate from markdownHeadings so each source
    // owns its own lifecycle.
    const librarySections = ref([]);
    // Type of the doc currently being viewed (from the library registry), set
    // by MarkdownPage. Drives the subscribe bar, which shows on writing
    // articles only.
    const currentDocType = ref(null);
    // Tags of the doc currently being viewed, used to pick the subscribe copy.
    const currentDocTags = ref([]);

    // Provide functions for markdown pages to update headings
    const updateMarkdownHeadings = (headings) => {
      markdownHeadings.value = headings;
    };

    const updateCurrentDocType = (type, tags) => {
      currentDocType.value = type || null;
      currentDocTags.value = Array.isArray(tags) ? tags : [];
    };

    const updateMarkdownActiveHeading = (activeHeading) => {
      markdownActiveHeading.value = activeHeading;
    };

    const updateLibrarySections = (sections) => {
      librarySections.value = Array.isArray(sections) ? sections : [];
    };

    provide('updateMarkdownHeadings', updateMarkdownHeadings);
    provide('updateMarkdownActiveHeading', updateMarkdownActiveHeading);
    provide('updateLibrarySections', updateLibrarySections);
    provide('updateCurrentDocType', updateCurrentDocType);

    // Subscribe bar (above the footer) shows on writing and on the open-source
    // tool pages.
    const showSubscribeBar = computed(() => ['article', 'tool'].includes(currentDocType.value));

    // Article-aware subscribe copy. A generic ask at the end of a specific
    // argument reads as boilerplate, so the second line names the thread the
    // reader was already following. First match wins; anything unmatched falls
    // back to the band's own default copy by passing empty strings.
    const SUBSCRIBE_LINES = [
      {
        tags: ['tokens', 'design-systems', 'storybook', 'design-engineering'],
        text: 'More on design systems, tokens, and the code that ships them.',
      },
      {
        tags: ['ai', 'agentic-ai', 'automation'],
        text: 'More on agentic work and what it does to design craft.',
      },
      {
        tags: ['design-tools', 'philosophy', 'front-end', 'open-source'],
        text: 'More on tools, formats, and who ends up owning them.',
      },
      {
        tags: ['career', 'mindset', 'leadership'],
        text: 'More on the shape of a design career as the tools change.',
      },
      {
        tags: ['qa', 'process', 'quality', 'velocity'],
        text: 'More on how the work actually ships.',
      },
      {
        tags: ['typography', 'visual-design', 'motion-design', 'craft'],
        text: 'More on craft at the level of type, colour, and motion.',
      },
    ];

    const subscribeCopy = computed(() => {
      const tags = currentDocTags.value || [];
      const match = SUBSCRIBE_LINES.find((rule) => rule.tags.some((t) => tags.includes(t)));
      if (!match) return { title: '', text: '' };
      return { title: 'This is the kind of thing I write about.', text: match.text };
    });

    // Sections shown in the mobile sticky bar, chosen by route: the Library
    // feeds its own section headers; article/doc pages reuse the markdown H2s.
    const stickySections = computed(() => {
      const path = router.currentRoute.value.path || '';
      if (path.startsWith('/library')) {
        return librarySections.value || [];
      }
      return (markdownHeadings.value || [])
        .filter((h) => h.level === 2 && h.slug && h.title)
        .map((h) => ({ id: h.slug, title: h.title }));
    });

    // The chat button stays off pages people come to read: essays and other
    // docs, case studies, collections and course sessions. There it is the
    // only app-like object on screen, and on mobile it sits over the text.
    // It stays on the pages people explore (home, Library, Work index, /hire)
    // and on the Ask Me Anything page, where a question is the point.
    const READING_ROUTES = [
      /^\/doc\//,
      /^\/work\/[^/]+/,
      /^\/collection\//,
      /^\/course\//,
      /^\/secured\/doc\//,
    ];
    const CHAT_ON_READING_ROUTES = ['/doc/ask-me-anything', '/doc/30'];
    const showChat = computed(() => {
      const route = router.currentRoute.value;
      if (route.meta?.hideChat) return false;
      const path = (route.path || '').replace(/\/+$/, '');
      if (CHAT_ON_READING_ROUTES.includes(path)) return true;
      return !READING_ROUTES.some((re) => re.test(path));
    });

    return {
      viewTransitionActive,
      showChat,
      markdownHeadings,
      markdownActiveHeading,
      librarySections,
      stickySections,
      currentDocType,
      currentDocTags,
      showSubscribeBar,
      subscribeCopy,
    };
  },
  data() {
    return {
      menuOpen: false,
    };
  },
  watch: {
    // Close the menu in the same render as the route change, so a page
    // transition captures the new page without the menu still on it.
    $route(to) {
      this.menuOpen = false;
      this.markHome(to);
    },
  },
  methods: {
    // Home has its own background in the light theme (main.scss). The class
    // goes on <html> so the page colour, the overscroll and the phone's
    // address bar (theme-color, read back from the body) all follow it.
    markHome(route) {
      document.documentElement.classList.toggle('is-home', route.path === '/');
      this.syncThemeColor();
    },
    syncThemeColor() {
      requestAnimationFrame(() => {
        const meta = document.querySelector('meta[name="theme-color"]');
        const bg = getComputedStyle(document.body).backgroundColor;
        if (meta && meta.getAttribute('content') !== bg) meta.setAttribute('content', bg);
      });
    },
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
    },
    closeMenu() {
      this.menuOpen = false;
    },
  },
  beforeUnmount() {
    this.themeObserver?.disconnect();
    this.schemeQuery?.removeEventListener('change', this.syncThemeColor);
  },
  mounted() {
    const router = useRouter();
    this.markHome(this.$route);
    // The theme toggle changes <html>'s class and the OS can switch scheme;
    // either changes the page colour, so the address bar follows.
    this.themeObserver = new MutationObserver(() => this.syncThemeColor());
    this.themeObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    this.schemeQuery = window.matchMedia('(prefers-color-scheme: dark)');
    this.schemeQuery.addEventListener('change', this.syncThemeColor);

    // Use Vue Router's afterEach hook to close the menu on route change
    router.afterEach((to) => {
      this.closeMenu();
      // Clear headings when navigating away from markdown pages
      if (!to.path.startsWith('/doc/')) {
        this.markdownHeadings = [];
        this.markdownActiveHeading = null;
        // Also drop the doc type so the subscribe bar hides off doc pages.
        this.currentDocType = null;
        this.currentDocTags = [];
      }
      // Clear library-fed sections when leaving the Library so the sticky bar
      // doesn't carry stale entries onto the next page.
      if (!to.path.startsWith('/library')) {
        this.librarySections = [];
      }
    });
  },

  // data() {
  //   return {
  //     userIsLoggedIn: false
  //   }
  // },
  // computed: {
  //   isLoggedIn() {
  //     return this.userIsLoggedIn
  //   }
  // },
  // methods: {
  //   handleLoginResult({loginResult}) {
  //     this.userIsLoggedIn = loginResult
  //   }
  // }
};
</script>

<style lang="scss">
@import './assets/styles/css/all.css';

/* Every page fills at least the viewport, so the footer stays below the fold
   while a page's content (markdown, data) is still arriving. */
.route-page {
  min-height: 100svh;
}

/* Route changes with the View Transitions API (src/utils/viewTransitions.js).
   The old screen lifts a little and fades; the new one rises in under it. The
   header has its own name so it holds still instead of moving with the page. */
#headernav {
  view-transition-name: site-header;
}
::view-transition-old(root),
::view-transition-new(root) {
  mix-blend-mode: normal;
}
::view-transition-old(root) {
  animation: vt-out var(--duration-fast) var(--ease-exit) both;
}
::view-transition-new(root) {
  animation: vt-in calc(var(--duration-base) + 80ms) var(--ease-standard) 60ms both;
}
@keyframes vt-out {
  to {
    opacity: 0;
    transform: translateY(-1.6rem);
  }
}
@keyframes vt-in {
  from {
    opacity: 0;
    transform: translateY(3.2rem);
  }
}

/* From the menu: the new page is already in place and the menu lifts off it
   like a sheet, top edge first. */
html.vt-from-menu::view-transition-old(root) {
  z-index: 1;
  animation: vt-sheet var(--duration-slow) var(--ease-emphasized) both;
}
html.vt-from-menu::view-transition-new(root) {
  animation: none;
}
@keyframes vt-sheet {
  to {
    clip-path: inset(0 0 100% 0);
  }
}

/* While a view transition runs, it does the animating: no Vue fades on top. */
html.vt-active .page-enter-active,
html.vt-active .menu-leave-active,
html.vt-active .menu-leave-active li {
  transition: none !important;
  animation: none !important;
}

/* Fallback route changes. No leave rule, so the outgoing page is removed at once. */
.page-enter-active {
  transition: opacity var(--duration-base) var(--ease-standard);
}
.page-enter-from {
  opacity: 0;
}
@media (prefers-reduced-motion: reduce) {
  .page-enter-active {
    transition: none;
  }
}

/* Full-width subscribe band above the footer (writing articles only). The
   `full` GridContainer drops the horizontal gutters so the bar spans the
   content width; its fill and radius live on the component. */

.slide-enter-from {
  transform: translateX(100%);
  opacity: 0;
}

.slide-enter-active {
  transition:
    transform 0.5s cubic-bezier(0.68, -0.55, 0.27, 1.55),
    opacity 0.5s cubic-bezier(0.68, -0.55, 0.27, 1.55);
}

.slide-enter-to {
  transform: translateX(0);
  opacity: 1;
}

.slide-leave-from {
  transform: translateX(0);
  opacity: 1;
}

.slide-leave-active {
  transition:
    transform 0.5s cubic-bezier(0.68, -0.55, 0.27, 1.55),
    opacity 0.5s cubic-bezier(0.68, -0.55, 0.27, 1.55);
}

.slide-leave-to {
  transform: translateX(100%);
  opacity: 0;
}

.avatar-standing {
  position: fixed;
  bottom: 0;
  right: -10rem;
  width: clamp(12rem, 35vw, 120rem); /* design-guard:ignore */
  pointer-events: none;
  z-index: 0;
}

/* Safety: hide legacy n8nchatui inline widget if it ever loads */
.n8n-chat-ui,
[class^='n8n-chat-ui'],
[class*=' n8n-chat-ui'],
[id*='n8n-chat-ui'],
[id*='n8nchatui'] {
  display: none !important;
  visibility: hidden !important;
  pointer-events: none !important;
}
</style>
